import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import Navbar from "./Navbar";
import Footer from "./Footer";
import drHelmy from "./assets/Dr helmy.jpeg";
import { DemographicsSection, PhotoAlbum } from "./MarketingSections";
import "./marketing.css";

const AboutPage = () => {
  return (
    <div className="xm-page">
      <Navbar />

      <section className="xm-about-hero">
        <div className="xm-wrap">
          <p className="xm-kicker">About X-Maths</p>
          <h1 className="xm-section-title xm-display" style={{ maxWidth: "22ch" }}>
            Built to help students settle top grades in Mathematics.
          </h1>
          <p className="xm-section-copy" style={{ marginTop: "1rem", maxWidth: "40rem" }}>
            X-Maths is an IGCSE Mathematics learning community founded by
            Dr Helmy Sherif — combining rigorous teaching with a supportive environment
            where students grow in confidence and performance.
          </p>
        </div>
      </section>

      <section className="xm-section">
        <div className="xm-wrap xm-about-grid">
          <div className="xm-portrait xm-portrait-square">
            <img src={drHelmy} alt="Dr Helmy Sherif" />
          </div>

          <div className="xm-about-copy">
            <p className="xm-role">Head Teacher &amp; Founder</p>
            <h2 className="xm-section-title xm-display">Dr Helmy Sherif</h2>
            <p className="xm-bio">
              Dr Helmy Sherif is a leader with over 12 years of experience in IGCSE OL
              and AL Mathematics (Edexcel) education, teaching thousands of students.
              He founded X-Maths to help students settle top grades in mathematics
              around the world.
            </p>
            <p className="xm-credential">
              Graduated from Cairo University, Faculty of Aerospace Engineering.
            </p>
          </div>
        </div>
      </section>

      <DemographicsSection
        kicker="Credentials &amp; reach"
        title="Experience that shows in every lesson"
      />

      <section className="xm-section xm-section-alt">
        <div className="xm-wrap xm-mission-grid">
          <div>
            <p className="xm-kicker">The mission</p>
            <h2 className="xm-section-title xm-display">Why X-Maths exists</h2>
            <p className="xm-section-copy">
              Too many students treat Maths as memorisation. X-Maths was founded to
              change that — teaching concepts clearly, connecting topics, and training
              students to think under exam pressure.
            </p>
          </div>
          <ul className="xm-checklist">
            <li>Specialised focus on Edexcel IGCSE OL &amp; AL Mathematics</li>
            <li>Teaching shaped by 12+ years in real classrooms</li>
            <li>A learning community that keeps students motivated</li>
            <li>Resources that mirror how exams are actually marked</li>
          </ul>
        </div>
      </section>

      <PhotoAlbum />

      <section className="xm-cta-band">
        <div className="xm-wrap">
          <h2 className="xm-section-title xm-display">Learn with X-Maths</h2>
          <p className="xm-section-copy">
            Start your journey toward stronger understanding and higher grades in
            IGCSE Mathematics.
          </p>
          <div className="xm-cta-row" style={{ justifyContent: "center" }}>
            <Link to="/signup" className="xm-btn xm-btn-primary">
              Sign Up <FaArrowRight />
            </Link>
            <Link to="/" className="xm-btn xm-btn-ghost">
              Back to home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
